import {put,call} from 'redux-saga/effects';
import { constants } from '../../constants';
import {toggleAlertShowStatus,getTermsAndConditionsSuccess} from '../actions';
import MulesoftDataService from '../../services/mulesoftData.services';

export default function * getTerms(args){
    try {
        const res = yield call([MulesoftDataService,'getTermsAndConditions'],args.payload.tId);
        yield put(getTermsAndConditionsSuccess(res))
    } catch (error) {
        yield put(toggleAlertShowStatus({
            showAlert: true,
            alertVarient:'danger',
            alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
          }));
    }
}